import React, { useEffect, useState } from "react";
import { getI18n, useTranslation } from "react-i18next";
import FormCreateQuestion from "../../../../components/Forms/FormCreateQuestion/FormCreateQuestion";
import {
  Category,
  QUESTION_TYPE,
  QuestionPayload,
  answerType,
  answerTypeIcon,
} from "../../../../models/SurveyModels";
import { useEndpoints } from "../../../../hooks/useEndpoints";
import { useNavigate, useParams } from "react-router-dom";
import { IOption } from "../../../../components/Forms/FormInput/FormSelect/FormSelect";
import { useToastAlert } from "../../../../components/ToastAlert/ToastAlert";
import { RoutesRouter } from "../../../../models/Routes";
import { DURATION_TOAST } from "../../../../utils/costants";
import { IErrorsCompanies } from "../../../../models/CompaniesModel";

export const CreateQuestions = () => {
  const { t } = useTranslation();

  const [question, setQuestion] = useState<QuestionPayload>();
  const [categories, setCategories] = useState<IOption[]>([]);
  const [answer, setAnswer] = useState<IOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { getQuestionbyId, getCategories, putQuestion, createQuestion } =
    useEndpoints();
  const { id } = useParams();
  const { showToast } = useToastAlert();

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      getQuestionbyId(id).then((resp) => {
        setQuestion(resp);
        setIsLoading(false);
      });
    }
    getCategories({
      language: getI18n().language.includes("it") ? "ITALIAN" : "ENGLISH",
    }).then((resp) => {
      const options: IOption[] = resp.map((category: Category) => {
        return {
          [category.name]: category.id,
          [category.icon]: "icon",
          [category.color]: "color",
          [category.background]: "background",
        };
      });
      setCategories(options);
    });
    const answerWhitIcon = answerType.map((item, index) => {
      return { ...item, ...answerTypeIcon[index] };
    });
    setAnswer(answerWhitIcon);
  }, [getCategories, getQuestionbyId, id, t]);
  const onSubmit = async (data: QuestionPayload) => {
    if (id) {
      const response = await putQuestion(id, {
        ...data,
        type: QUESTION_TYPE.STANDARD,
      });
      if (response.status === 200) {
        navigate(RoutesRouter.questions);
        showToast({
          message: `${t("home.questions.toast.success.edit")}`,
          type: "success",
          duration: DURATION_TOAST,
        });
      }
      if (response.status === 400) {
        const { errors } = await response.json();
        errors.map(({ value, msg, param }: IErrorsCompanies) =>
          showToast({
            message: `${msg} ${param}`,
            subMessage: value,
            type: "error",
          })
        );
      }
      if (response.status === 500) {
        showToast({
          message: `${t("home.questions.toast.error.generic")}`,
          type: "error",
        });
      }
    } else {
      const response = await createQuestion({
        ...data,
        type: QUESTION_TYPE.STANDARD,
      });
      if (response.status === 201) {
        navigate(RoutesRouter.questions);
        showToast({
          message: `${t("home.questions.toast.success.create")}`,
          type: "success",
          duration: DURATION_TOAST,
        });
      }
      if (response.status === 400) {
        const { errors } = await response.json();
        errors.map(({ value, msg, param }: IErrorsCompanies) =>
          showToast({
            message: `${msg} ${param}`,
            subMessage: value,
            type: "error",
          })
        );
      }
      if (response.status === 500) {
        showToast({
          message: `${t("home.questions.toast.error.generic")}`,
          type: "error",
        });
      }
    }
  };
  return (
    <div className="container-custom custom-form-container">
      <div className="container__home">
        <FormCreateQuestion
          isLoading={isLoading}
          onSumbitForm={onSubmit}
          answerType={answer}
          questionData={question}
          categories={categories}
        />
      </div>
    </div>
  );
};
